export const GRADE_POINTS = {
  S: 10,
  A: 9,
  B: 8,
  C: 7,
  D: 6,
  E: 5,
  F: 0
};

export const GRADE_OPTIONS = Object.keys(GRADE_POINTS);
